<template>
  <div class="carousel_panel">
    <el-carousel height="400px" :interval="3000" @change="carouselChange" :loop="loop">
      <template v-for="i in 2">
        <el-carousel-item v-for="(item, index) in bannerList" :key="i + '_' + index">
          <div class="content" :style="{ backgroundImage: 'url(' + item + ')' }" />
        </el-carousel-item>
      </template>
      <div class="indicator_box">
        <div class="indicator">
          <div v-for="index in bannerList.length" :key="index" :class="{ active: active === index - 1 }"></div>
        </div>
      </div>
    </el-carousel>
  </div>
</template>
<script>
export default {
  name: "carousel_panel",
  data() {
    return {
      active: 0,
      loop: true,
      bannerList: [require("@/assets/images/home/carousel_1.png"), require("@/assets/images/home/carousel_2.png")],
    };
  },
  methods: {
    carouselChange(index) {
      this.active = index % 2;
    },
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
